
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class AuthenticCard extends Vue {
  
  @Prop()
  title!: string;

  @Prop()
  align!: string

  @Prop()
  onClose?: () => void;

  alignment = "align-self-center"

  closeClicked() {
    if (this.onClose) {
      this.onClose();
    }
  }
}
